import { base_url } from "../../constants";
import { propsIndividual_obra } from "../../models/Colecciones.model";
import { pathImages } from "../../routes/endpoints";
import Sin_imagen from "../../assets/images/sin_imagen.png";

export default function Elemento(props: propsIndividual_obra) { 
    return(        
        <div className={`col-12 col-sm-6 col-md-4 col-lg-2 mx-0 mx-lg-2 ${props.valida_clase}`}>
            <a href={`/${base_url}/obras/${props.id}`} className="link_book_collection">
                <div className="card card_book border-0"> 
                    <div className="d-flex justify-content-center divImages" >                      
                        { (props.imagen === '' || props.imagen === null)? <img src={`${Sin_imagen}`} className="img_card_book tamanioImg" alt="book collection"/> 
                         : <img src={`${pathImages}${props.imagen}`} className="img_card_book tamanioImg" alt="book collection"/> } 
                    </div>
                    <div className="card-body pt-1" style={{fontSize: "1rem", lineHeight: "1.3rem"}}>
                        <p className="card-text">{props.anio}</p>
                        <p className="card-text"  > <div dangerouslySetInnerHTML={{__html: `${props.descripcion}` }}></div></p>
                    </div>
                </div>
            </a>
        </div>
    );

}
